function AboutUs() {
  const values = [
    { 
      icon: '🎯', 
      title: 'Innovation', 
      desc: 'We constantly evolve with cutting-edge real estate technology, ensuring our clients stay ahead of market trends.',
      details: 'AI-powered insights, predictive analytics, and automation tools'
    },
    { 
      icon: '🤝', 
      title: 'Integrity', 
      desc: 'We operate with transparency, honesty, and ethical business practices in every transaction.',
      details: 'Clear pricing, data privacy, and compliance with global standards'
    },
    { 
      icon: '⭐', 
      title: 'Excellence', 
      desc: 'We deliver premium quality in every feature, from lead management to financial reporting.',
      details: '99.9% uptime, continuous improvement, and customer-first approach'
    },
    { 
      icon: '🌍', 
      title: 'Global Reach', 
      desc: 'We serve real estate professionals across USD, EUR, and NGN markets with localized solutions.',
      details: 'Multi-currency support, international compliance, and global best practices'
    },
    { 
      icon: '💡', 
      title: 'Customer Success', 
      desc: 'We are committed to your growth, providing training and support every step of the way.',
      details: '24/7 support, onboarding assistance, and dedicated account managers'
    },
    { 
      icon: '🔒', 
      title: 'Security', 
      desc: 'Your data is protected with enterprise-grade security and bank-level encryption.',
      details: 'GDPR compliant, regular audits, and secure document storage'
    }
  ]

  const valueProps = [
    { icon: '💰', title: 'Save Time & Money', desc: 'Replace 6+ separate tools with one integrated platform. Reduce software costs by up to 70%.', stat: '70% savings' },
    { icon: '📊', title: 'Data-Driven Decisions', desc: 'Real-time analytics, lead insights, and performance tracking to grow your business.', stat: '50K+ leads' },
    { icon: '🔒', title: 'Enterprise-Grade Security', desc: 'Bank-level encryption, secure document storage, and compliance with global standards.', stat: '99.9% secure' },
    { icon: '🌐', title: 'Multi-Currency Support', desc: 'Seamlessly work with USD, EUR, and NGN - perfect for international real estate.', stat: '3 currencies' },
    { icon: '⚡', title: 'Lightning Fast', desc: 'Optimized for speed with real-time updates and instant notifications.', stat: '< 1s response' },
    { icon: '📱', title: 'Mobile Ready', desc: 'Access your CRM from anywhere, on any device, with our responsive design.', stat: '100% mobile' }
  ]

  const team = [
    { name: 'Rizqah Olajide Adedokun', role: 'Founder & CEO', bio: '5+ years in real estate technology. Former real estate agent turned tech entrepreneur.', expertise: 'Real Estate Strategy' },
    { name: 'Sarah Johnson', role: 'Head of Product', bio: 'Former real estate agent with 8 years of experience. Passionate about user-centric design.', expertise: 'Product Management' },
    { name: 'Michael Chen', role: 'CTO', bio: 'Cloud architecture specialist with 12 years in SaaS. Leads our engineering team.', expertise: 'Cloud Architecture' },
    { name: 'Amara Okonkwo', role: 'Customer Success', bio: 'Real estate operations expert ensuring our clients achieve their goals.', expertise: 'Client Relations' },
    { name: 'David Williams', role: 'Head of Sales', bio: '15 years in B2B SaaS sales. Focused on enterprise partnerships.', expertise: 'Enterprise Sales' },
    { name: 'Grace Mbatia', role: 'Marketing Director', bio: 'Digital marketing specialist with expertise in real estate branding.', expertise: 'Digital Marketing' }
  ]

  return (
    <div style={containerStyle}>
      {/* Hero Section */}
      <div style={heroStyle}>
        <h1 style={heroTitle}>About EstatesFlow</h1>
        <p style={heroSubtitle}>Empowering Real Estate Professionals Worldwide</p>
        <p style={heroDesc}>Join thousands of agents, brokerages, and property managers using EstatesFlow to transform their business.</p>
      </div>

        <div style={{ textAlign: 'center', marginTop: 20 }}>
          <button onClick={() => window.location.href = '/'} style={{ background: '#1e3a5f', color: '#fff', border: 'none', padding: '10px 20px', borderRadius: 8, cursor: 'pointer' }}>← Back to Home</button>
        </div>

      {/* Mission & Vision Section */}
      <div style={missionVisionSection}>
        <div style={missionCard}>
          <div style={iconLarge}>🎯</div>
          <h2>Our Mission</h2>
          <p>To empower real estate professionals with an intuitive, all-in-one platform that simplifies complex workflows, enabling them to focus on what matters most - serving their clients and growing their business.</p>
          <div style={missionPoints}>
            <span>✅ Simplify Operations</span>
            <span>✅ Boost Productivity</span>
            <span>✅ Drive Growth</span>
          </div>
        </div>
        <div style={visionCard}>
          <div style={iconLarge}>👁️</div>
          <h2>Our Vision</h2>
          <p>To become the global standard for real estate management software, serving millions of agents and property professionals across USD, EUR, and NGN markets.</p>
          <div style={visionPoints}>
            <span>🌍 Global Leader</span>
            <span>📈 Industry Innovation</span>
            <span>🤝 Trusted Partner</span>
          </div>
        </div>
      </div>

      {/* Story Section */}
      <div style={storySection}>
        <div style={storyContent}>
          <h2>Our Story</h2>
          <p>Founded in 2025, EstatesFlow was born from a simple observation: real estate professionals were juggling multiple disconnected tools - spreadsheets for leads, separate CRMs for properties, accounting software for finances, and manual processes for legal documents.</p>
          <p>We set out to build a single, unified platform that brings everything together. Today, EstatesFlow serves hundreds of real estate agents, brokerages, and property managers across Africa, Europe, and the United States.</p>
          <div style={statsStory}>
            <div><span>500+</span><br />Active Agents</div>
            <div><span>10K+</span><br />Properties Listed</div>
            <div><span>50K+</span><br />Leads Generated</div>
            <div><span>99.9%</span><br />Uptime</div>
          </div>
        </div>
        <div style={storyImage}>
          <div style={placeholderImage}>
            <div style={placeholderIcon}>🏢</div>
            <p>EstatesFlow Headquarters</p>
            <small>Abuja, Nigeria</small>
          </div>
        </div>
      </div>

      {/* Values Section - FULLY POPULATED */}
      <div style={valuesSection}>
        <h2 style={sectionTitle}>Our Core Values</h2>
        <p style={sectionSubtitle}>These principles guide everything we do at EstatesFlow.</p>
        <div style={valuesGrid}>
          {values.map((v, i) => (
            <div key={i} style={valueCard}>
              <div style={valueIcon}>{v.icon}</div>
              <h3>{v.title}</h3>
              <p>{v.desc}</p>
              <div style={valueDetail}>{v.details}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Value Proposition Section */}
      <div style={valuePropSection}>
        <h2 style={sectionTitle}>Why Choose EstatesFlow?</h2>
        <p style={sectionSubtitle}>The all-in-one solution for modern real estate professionals</p>
        <div style={valuePropGrid}>
          {valueProps.map((vp, i) => (
            <div key={i} style={valuePropCard}>
              <div style={valuePropIcon}>{vp.icon}</div>
              <h3>{vp.title}</h3>
              <p>{vp.desc}</p>
              <div style={valuePropStat}>{vp.stat}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Team Section */}
      <div style={teamSection}>
        <h2 style={sectionTitle}>Meet Our Leadership Team</h2>
        <p style={sectionSubtitle}>Dedicated experts committed to your success</p>
        <div style={teamGrid}>
          {team.map((t, i) => (
            <div key={i} style={teamCard}>
              <div style={teamAvatar}>{t.image}</div>
              <h3>{t.name}</h3>
              <p style={teamRole}>{t.role}</p>
              <p style={teamBio}>{t.bio}</p>
              <div style={teamExpertise}>{t.expertise}</div>
            </div>
          ))}
        </div>
      </div>

      {/* CTA Section */}
      <div style={ctaSection}>
        <h2>Ready to Transform Your Real Estate Business?</h2>
        <p>Join thousands of professionals using EstatesFlow to manage properties, leads, and finances.</p>
        <button style={ctaButton} onClick={() => window.location.href = '/'}>Start Free Trial →</button>
      </div>
    </div>
  )
}

const containerStyle = { fontFamily: "'Inter', sans-serif", color: '#1e293b' }
const heroStyle = { background: 'linear-gradient(135deg, #1e3a5f 0%, #0f2b42 100%)', color: '#fff', textAlign: 'center', padding: '80px 20px' }
const heroTitle = { fontSize: 48, marginBottom: 16 }
const heroSubtitle = { fontSize: 20, opacity: 0.9, maxWidth: 600, margin: '0 auto' }
const heroDesc = { fontSize: 16, opacity: 0.8, maxWidth: 500, margin: '20px auto 0' }
const missionVisionSection = { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: 30, maxWidth: 1000, margin: '0 auto', padding: '60px 20px' }
const missionCard = { textAlign: 'center', padding: 40, borderRadius: 20, border: '1px solid #e2e8f0', background: '#fff', boxShadow: '0 4px 6px rgba(0,0,0,0.05)' }
const visionCard = { textAlign: 'center', padding: 40, borderRadius: 20, border: '1px solid #e2e8f0', background: '#fff', boxShadow: '0 4px 6px rgba(0,0,0,0.05)' }
const iconLarge = { fontSize: 48, marginBottom: 16 }
const missionPoints = { display: 'flex', justifyContent: 'center', gap: 15, marginTop: 20, fontSize: 14, color: '#2c7da0', flexWrap: 'wrap' }
const visionPoints = { display: 'flex', justifyContent: 'center', gap: 15, marginTop: 20, fontSize: 14, color: '#2c7da0', flexWrap: 'wrap' }
const storySection = { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: 40, maxWidth: 1200, margin: '0 auto', padding: '60px 20px', alignItems: 'center' }
const storyContent = { padding: 20 }
const storyImage = { textAlign: 'center' }
const placeholderImage = { background: 'linear-gradient(135deg, #1e3a5f 0%, #0f2b42 100%)', padding: 40, borderRadius: 20, color: '#fff' }
const placeholderIcon = { fontSize: 80, marginBottom: 20 }
const statsStory = { display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 20, marginTop: 30, textAlign: 'center' }
const valuesSection = { background: '#f8fafc', padding: '60px 20px' }
const sectionTitle = { textAlign: 'center', fontSize: 32, marginBottom: 8 }
const sectionSubtitle = { textAlign: 'center', color: '#64748b', marginBottom: 40 }
const valuesGrid = { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))', gap: 30, maxWidth: 1200, margin: '0 auto' }
const valueCard = { textAlign: 'center', padding: 30, borderRadius: 16, background: '#fff', border: '1px solid #e2e8f0', transition: 'transform 0.2s' }
const valueIcon = { fontSize: 48, marginBottom: 16 }
const valueDetail = { fontSize: 12, color: '#2c7da0', marginTop: 12, padding: '8px 12px', background: '#f0f4f8', borderRadius: 20, display: 'inline-block' }
const valuePropSection = { padding: '60px 20px', maxWidth: 1200, margin: '0 auto' }
const valuePropGrid = { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: 30 }
const valuePropCard = { textAlign: 'center', padding: 30, borderRadius: 16, background: '#fff', border: '1px solid #e2e8f0', transition: 'transform 0.2s' }
const valuePropIcon = { fontSize: 48, marginBottom: 16 }
const valuePropStat = { marginTop: 15, fontSize: 14, fontWeight: 'bold', color: '#059669', background: '#d1fae5', padding: '6px 12px', borderRadius: 20, display: 'inline-block' }
const teamSection = { background: '#f8fafc', padding: '60px 20px' }
const teamGrid = { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: 30, maxWidth: 1200, margin: '0 auto' }
const teamCard = { textAlign: 'center', padding: 30, borderRadius: 16, background: '#fff', border: '1px solid #e2e8f0', transition: 'transform 0.2s' }
const teamAvatar = { fontSize: 60, marginBottom: 16 }
const teamRole = { color: '#2c7da0', fontWeight: 600, margin: '8px 0' }
const teamBio = { color: '#64748b', fontSize: 14, lineHeight: 1.5 }
const teamExpertise = { fontSize: 12, background: '#f0f4f8', padding: '4px 12px', borderRadius: 20, display: 'inline-block', marginTop: 12 }
const ctaSection = { textAlign: 'center', padding: '60px 20px', background: 'linear-gradient(135deg, #1e3a5f 0%, #0f2b42 100%)', color: '#fff' }
const ctaButton = { background: '#f59e0b', color: '#fff', border: 'none', padding: '15px 40px', fontSize: 18, borderRadius: 50, cursor: 'pointer', fontWeight: 'bold', marginTop: 20 }
const blogGrid = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
  gap: 30,
  maxWidth: 1200,
  margin: '40px auto',
  padding: '0 20px'
}

const blogCard = {
  background: '#fff',
  borderRadius: 20,
  overflow: 'hidden',
  border: '1px solid #e2e8f0',
  transition: 'transform 0.2s',
  cursor: 'pointer',
  marginBottom: 20
}


export default AboutUs
